/** EAEU Efficient Auxiliary Engine Use (formerly AEU) */
import React from "react";
import BehaviourBarGraph from "../BehaviourBarGraph.jsx";
import {
  formatDuration,
  formatPercentage,
} from "@signolteam/shared/units-of-measure";

import AppUtils from "@src/utils/appUtils";

let defaultMetadata = {
  eaeu_threshold_hours: 1,
  overused_running_hours: 0.75,
  aeu: 0.75,
  aeu_lower_threshold: 0.7,
  constant_aeu_lower: 70,
  constant_aeu_upper: 100,
};

export const behaviourMetadataFields = Object.keys(defaultMetadata);
export default function graph({
  unit = "%",
  metadata = defaultMetadata,
  missingDataMsg,
  bvrColour,
  customerCode,
  isExample,
}) {
  const featureCheck = AppUtils.isFeatureAvailableForCustomer;

  let overProdHours = metadata["overused_running_hours"];
  let overProdThreshold = metadata["eaeu_threshold_hours"] || 3; // hard coded value of three hours for ships without a threshold
  let engineValue = metadata["aeu"];
  let threshold = metadata["aeu_lower_threshold"];
  let min = metadata["constant_aeu_lower"];
  let max = metadata["constant_aeu_upper"];

  let actual = Number(engineValue);
  overProdHours = Number(overProdHours);
  overProdThreshold = Number(overProdThreshold);
  threshold = Number(threshold);

  if (isNaN(overProdHours) || isNaN(overProdThreshold)) {
    return (
      <div className="relative text-center my-6 mx-auto text-2xl fill-current">
        {missingDataMsg}
      </div>
    );
  }
  let graphProps = {};

  const thresholdSeconds = overProdThreshold * 60 * 60;
  const overProdHoursInSeconds = overProdHours * 60 * 60;
  const data = [
    {
      name: "Excess AE running hours",
      mobileName: "Label",
      beforeThreshold:
        overProdHoursInSeconds > thresholdSeconds
          ? thresholdSeconds
          : overProdHoursInSeconds,
      afterThreshold:
        overProdHoursInSeconds > thresholdSeconds
          ? overProdHoursInSeconds - thresholdSeconds
          : 0,
      underThresholdColour:
        overProdHoursInSeconds <= thresholdSeconds
          ? bvrColour.codes["500"]
          : bvrColour.codes["200"],
      overThresholdColour: bvrColour.codes["900"],
    },
  ];

  const numOfTicks =
    overProdHoursInSeconds < thresholdSeconds
      ? Math.ceil(overProdThreshold) + 3
      : Math.ceil(overProdHours) + 3; // add 3 for label space

  const domainMin = 0;
  const domainMax = numOfTicks * 60 * 60;
  const domain = [domainMin, domainMax];

  const mobileMargin =
    overProdHoursInSeconds < thresholdSeconds
      ? 0.05 * thresholdSeconds
      : 0.05 * overProdHoursInSeconds;
  const mobileDomainMax =
    overProdHoursInSeconds < thresholdSeconds
      ? Math.ceil(thresholdSeconds + mobileMargin)
      : Math.ceil(overProdHoursInSeconds + mobileMargin);
  const mobileDomain = [domainMin, mobileDomainMax];

  const thresholdLineColour = bvrColour.codes["900"];

  const ticks = [];
  for (let i = 0; i < numOfTicks; i++) {
    ticks.push((i + 1) * 60 * 60);
  }

  graphProps = {
    data,
    threshold: thresholdSeconds,
    thresholdLabel: `Signol threshold ${!isExample ? `(${overProdThreshold} hr)` : ""}`,
    mobileDomain,
    domain,
    refLineColour: thresholdLineColour,
    success: !(thresholdSeconds < overProdHoursInSeconds),
    unitOfMeasure: unit,
    axisLabel: "Time",
    hideYLine: true,
    hideNum: true,
    barLabelFormatter: (value) => `${formatDuration(value).formattedValue}`,
    ticks: ticks,
  };

  return <BehaviourBarGraph {...graphProps} isExample={isExample} />;
}
